import { render } from "./ThePhanLoaiTruongMamNon.vue?vue&type=template&id=2ebe0a8a"
import script from "./ThePhanLoaiTruongMamNon.vue?vue&type=script&lang=js"
export * from "./ThePhanLoaiTruongMamNon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__